export const CONFIGURATION = 'CONFIGURATION'
export const SET_CONFIGURATION = 'SET_CONFIGURATION'
export const SET_CONFIGURATION_DATA_LOADED = 'SET_CONFIGURATION_DATA_LOADED'
export const RESET_CONFIGURATION_DATA_LOADED = 'RESET_CONFIGURATION_DATA_LOADED'
